import styled from "styled-components";

export const StyledTabsButton = styled.div`
  flex: 1;
  display: flex;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  justify-content: center;
  align-items: center;
`;

export const StyledTabsHead = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
